'use strict';
var parent = require('../../stable/weak-map');
require('../../modules/esnext.weak-map.get-or-insert');
require('../../modules/esnext.weak-map.get-or-insert-computed');

module.exports = parent;
